import {
	FieldValues,
	FieldPath,
	UseControllerProps,
	useController,
} from 'react-hook-form';
import {
	IconButton,
	InputAdornment,
	OutlinedInput,
	TextField,
} from '@mui/material';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';

interface Props {
	placeholder?: string;
	autoMinWidth?: boolean;
	nextFileNo: string;
}

export default function AppGetNextNumber<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
	placeholder,
	autoMinWidth,
	nextFileNo,
	...props
}: Props & UseControllerProps<TFieldValues, TName>) {
	const { field } = useController(props);
	const valueChange = field.onChange;

	const handleAdd = () => {
		const newValue = Number(field.value) + 1;
		if (String(newValue).length == 2) {
			valueChange('0' + newValue);
		}
		if (String(newValue).length == 1) {
			valueChange('00' + newValue);
		}
		const parts = nextFileNo.split('/');

		valueChange(parts[3]);
	};
	return (
		<>
			<OutlinedInput
				{...field}
				sx={{ width: '100%' }}
				placeholder={placeholder}
				endAdornment={
					<InputAdornment position='end'>
						<IconButton type='button' onClick={handleAdd}>
							<LoopOutlinedIcon />
						</IconButton>
					</InputAdornment>
				}
				inputProps={{ maxLength: 3 }}
				onChange={(e) => {
					const newValue = e.target.value.replace(/[^0-9]/g, '');
					field.onChange(newValue);
				}}
				onBlur={(e) => {
					if (String(e.target.value).length == 2) {
						field.onChange('0' + e.target.value);
					} else if (String(e.target.value).length == 1) {
						field.onChange('00' + e.target.value);
					}
				}}
			/>
		</>
	);
}
